import React from 'react';
import { Button } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const SingleOptionButton = ({
  label = 'Confirm',
  onClick = () => {},
  type = 'button',
  formId,
  dataAnalyticsId = '',
  cypressId = undefined,
  isDisabled = false,
  isLoading = false,
  loadingText = ''
}) => (
  <Button
    isRound
    data-analytics-id={dataAnalyticsId}
    data-cy={cypressId}
    form={formId}
    isDisabled={isDisabled}
    isLoading={isLoading}
    loadingText={loadingText}
    size="lg"
    type={type}
    variant="gradientPrimary"
    width="180px"
    onClick={onClick}
  >
    {label}
  </Button>
);

SingleOptionButton.propTypes = {
  /** Text displayed on button. Defaults to 'Confirm' */
  label: PropTypes.string,
  /** Event handler for button */
  onClick: PropTypes.func,
  /** Analytics tracking id for button */
  dataAnalyticsId: PropTypes.string,
  /** Cypress testing id for button.  Do not touch */
  cypressId: PropTypes.string,
  /** Button can be of type button or submit */
  type: PropTypes.string,
  /** Required if the button type is submit. ID of the form being submitted */
  formId: PropTypes.string,
  /** Button will be disabled if `true` */
  isDisabled: PropTypes.bool,
  /** Button will be disabled and show a loading spinner `true` */
  isLoading: PropTypes.bool,
  /** Accompanying text for the loading spinner if isLoading is `true`. Will show on right of spinner */
  loadingText: PropTypes.string
};

export default SingleOptionButton;
